/**
 * 生成唯一 UUID
 * @returns {string} UUID 字符串
 */
export function generateUUID() {
  if (typeof crypto !== "undefined" && crypto.randomUUID) {
    return crypto.randomUUID();
  }

  // 兼容方案
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
    const r = (Math.random() * 16) | 0;
    const v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

/**
 * 生成短 UUID（8位）
 * @returns {string} 短 UUID 字符串
 */
export function generateShortUUID() {
  return "xxxxxxxx".replace(/[x]/g, function () {
    return ((Math.random() * 16) | 0).toString(16);
  });
}

/**
 * 生成带时间戳的唯一 ID
 * @param {string} prefix 前缀
 * @returns {string} 唯一 ID
 */
export function generateUniqueId(prefix = "") {
  const timestamp = Date.now().toString(36);
  const random = Math.random().toString(36).substring(2, 8);
  return prefix ? `${prefix}_${timestamp}${random}` : `${timestamp}${random}`;
}

export default {
  generateUUID,
  generateShortUUID,
  generateUniqueId,
};
